@if (tenant) {
  <div class="tenant-image-container" [class.active]="showActive && state.activeTenant?.id === tenant.id">
    @if (tenant.favicon_url) {
      <img [src]="tenant.favicon_url" class="tenant-image" alt="" />
    }
    @if (!tenant.favicon_url) {
      <div class="tenant-image no-image">
        {{ (tenant.name || 'u' | uppercase)[0] }}
      </div>
    }
  </div>
}
